import { cva } from '@/styled-system/css/cva.mjs';

export const bannerBoxRecipe = cva({
  base: {
    marginBlock: '400',
    marginInline: 'auto',
    boxSizing: 'content-box',
  },
  variants: {
    isEnterpriseCustomer: {
      true: {},
      false: {
        // Non-enterprise view has banners outside of Page.Content, so we need to duplicate spacing
        maxWidth: 'Page.width.max',
        paddingInline: {
          base: 'Page.padding.horz.mobile',
          md: 'Page.padding.horz.tablet',
          xl: 'Page.padding.horz.desktop',
        },
      },
    },
  },
});
